import { StaticCardTypes } from '@shared/components/cards/card-types';
import Card from '@shared/components/cards/default-cards';
import ToggleField from '@shared/components/forms/form-components/toggles/toggle-field';
import { html } from '@shared/utils/rendering/html';

export const SystemsFormLayout = {
    systemName: {
        column: 'col-3',
        formGroup: '',
        css: '',
    },
    url: { column: 'col-3', formGroup: '', css: '' },
    ownerUserName: { column: 'col-3', formGroup: '', css: '', disabled: true },
    createdDateUtc: { column: 'col-3', formGroup: '', css: '', disabled: true },
    isActive: { column: 'col-3', formGroup: '', css: '' },
    maintenanceMessage: { column: 'col-6', formGroup: '', css: '' },
    estimatedReturnUtc: { column: 'col-3', formGroup: '', css: '' },
};

export const SystemsFormOptions = {
    layout: SystemsFormLayout,
    includeSaveButton: false,
    textareaBoundary: 1000,
    formProps: {
        disabled: false,
    },
    overrides: {
        isActive: (inputProps, layoutSettings, options, fieldDesc, fieldRef) => {
            const render = html`<${ToggleField}
                inputProps=${inputProps}
                layoutSettings=${layoutSettings}
                options=${options}
                ref=${fieldRef}
            />`;
            return { render, fieldRef };
        },
    },
    converters: {},
    sections: [
        {
            parent: Card,
            parentProps: {
                header: { title: 'System Information' },
                content: { type: StaticCardTypes.other },
                css: 'my-3',
            },
            fields: ['systemName', 'url', 'ownerUserName', 'createdDateUtc', 'isActive'],
        },
        {
            parent: Card,
            parentProps: {
                header: { title: 'Maintenance Details' },
                content: { type: StaticCardTypes.other },
                css: 'my-3',
            },
            fields: ['maintenanceMessage', 'estimatedReturnUtc'],
        },
    ],
};
